import { formatDateWithLocalTZ } from "@ticomix/common";
import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch,
} from "rxjs/operators";
import {
  Observable,
  throwError as _observableThrow,
  of as _observableOf,
} from "rxjs";
import { Injectable, Inject, Optional, InjectionToken } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
} from "@angular/common/http";

import { ITokenResponse } from "./i-itoken-response";
import { throwException, blobToText } from "./api-utilities";

export class TokenResponse implements ITokenResponse {
  AccessToken!: string;
  RefreshToken?: string | null;
  ExpiresIn!: number;
  TokenType!: string;
  Metadata?: { [key: string]: any } | null;

  constructor(data?: ITokenResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.AccessToken = "";
      this.ExpiresIn = 0;
      this.TokenType = "";
    }
  }

  init(_data?: any) {
    if (_data) {
      this.AccessToken =
        _data["AccessToken"] !== undefined ? _data["AccessToken"] : "";
      this.RefreshToken =
        _data["RefreshToken"] !== undefined ? _data["RefreshToken"] : <any>null;
      this.ExpiresIn =
        _data["ExpiresIn"] !== undefined ? _data["ExpiresIn"] : 0;
      this.TokenType =
        _data["TokenType"] !== undefined ? _data["TokenType"] : "";
      if (_data["Metadata"]) {
        this.Metadata = {} as any;
        for (let key in _data["Metadata"]) {
          if (_data["Metadata"].hasOwnProperty(key))
            (<any>this.Metadata)![key] =
              _data["Metadata"][key] !== undefined
                ? _data["Metadata"][key]
                : <any>null;
        }
      } else {
        this.Metadata = <any>null;
      }
    }
  }

  static fromJS(data: any): TokenResponse {
    data = typeof data === "object" ? data : {};
    let result = new TokenResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["AccessToken"] =
      this.AccessToken !== undefined ? this.AccessToken : <any>null;
    data["RefreshToken"] =
      this.RefreshToken !== undefined ? this.RefreshToken : <any>null;
    data["ExpiresIn"] =
      this.ExpiresIn !== undefined ? this.ExpiresIn : <any>null;
    data["TokenType"] =
      this.TokenType !== undefined ? this.TokenType : <any>null;
    if (this.Metadata) {
      data["Metadata"] = {};
      for (let key in this.Metadata) {
        if (this.Metadata.hasOwnProperty(key))
          (<any>data["Metadata"])[key] =
            this.Metadata[key] !== undefined ? this.Metadata[key] : <any>null;
      }
    }
    return data;
  }
}
